import { useCallback } from 'react';
import {
  useQuery,
  QueryResult,
  useLazyQuery,
  useApolloClient,
  QueryOptions,
  OperationVariables,
  QueryHookOptions,
  LazyQueryHookOptions,
  LazyQueryExecFunction
} from '@apollo/client';
import { useSnackbarHelper } from '../../useSnackbarHelper';
import QUERY from '../operations/TiktokAdvertiserSummaryData.graphql';
import { Query } from '../../__generated__/globalTypes';

export const useTiktokAdvertiserSummaryDataQuery = (options?: QueryHookOptions<Query>) => {
  const { t, enqueueSnackbar } = useSnackbarHelper();
  const result = useQuery<Query>(QUERY, {
    onError: (error) => {
      enqueueSnackbar(t(error.message), { variant: 'error' });
    },
    ...options
  });

  return result;
};

export const useTiktokAdvertiserSummaryDataLazyQuery = (
  options?: LazyQueryHookOptions<Query>
): QueryResult<Query> & { getTiktokAdvertiserSummaryDataQuery: LazyQueryExecFunction<Query, OperationVariables> } => {
  const { t, enqueueSnackbar } = useSnackbarHelper();
  // TODO: should be getTiktokAdvertiserSummaryData
  const [getTiktokAdvertiserSummaryDataQuery, result] = useLazyQuery<Query>(QUERY, {
    onError: (error) => {
      enqueueSnackbar(t(error.message), { variant: 'error' });
    },
    ...options
  });

  return { getTiktokAdvertiserSummaryDataQuery, ...result };
};

export const useTiktokAdvertiserSummaryDataPromiseQuery = () => {
  const client = useApolloClient();

  const getTiktokAdvertiserSummaryData = useCallback(
    (options?: Omit<QueryOptions<Record<string, unknown>, Query>, 'query'>) =>
      client.query<Query>({ ...options, query: QUERY }),
    [client]
  );

  return { getTiktokAdvertiserSummaryData };
};
